import React from 'react';
import { Tag, Intent } from '@blueprintjs/core';
import Icon from '@hobs/components/Icon';

// Helper function to paint tree from response object
export const buildTree = (fn, [head, ...rest]) => {
  if (head === undefined && !rest.length) {
    return [];
  }
  if (head && head.units && head.units.length) {
    return [
      { ...fn(head), childNodes: buildTree(fn, head.units) },
      ...buildTree(fn, rest)
    ];
  }
  return [fn(head), ...buildTree(fn, rest)];
};

export const getUnitObject = selectedUnitId => unit => {
  const isSelected = unit.unitId === selectedUnitId;
  return {
    ...unit,
    isExpanded: true,
    hasCaret: false,
    isSelected,
    secondaryLabel: [
      getTags(unit.statuses),
      (isSelected && (
        <span className="selected-item" key="arrow">
          <Icon icon="ArrowRightOutline" />
        </span>
      )) ||
        null
    ],
    id: unit.unitId,
    key: unit.unitId,
    label: unit.unitName
  };
};

// 0 - None, 1- Empty, 2- PartiallyFilled, 3 - Completed, 4 - Inactive
const getTags = statuses => {
  if (!statuses) {
    return null;
  }

  return statuses.map((status, index) => {
    let intent = Intent.NONE;
    let icon = null;

    if (status.type <= 0) {
      return null;
    }

    switch (status.type) {
    case 1:
      icon = 'small-cross';
      intent = Intent.DANGER;
      break;
    case 2:
      icon = 'info-sign';
      intent = Intent.WARNING;
      break;
    case 3:
      icon = 'small-tick';
      intent = Intent.SUCCESS;
      break;
    }
    return (
      <Tag intent={intent} key={index} icon={icon}>
        {status.text}
      </Tag>
    );
  });
};
